"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendToUrlPathname = void 0;
function appendToUrlPathname(url, append) {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname;
    parsedUrl.pathname = `${path}${path.endsWith("/") ? "" : "/"}${append.startsWith("/") ? append.substring(1) : append}`;
    return parsedUrl.toString();
}
exports.appendToUrlPathname = appendToUrlPathname;
//# sourceMappingURL=urlPath.js.map